import React, {ReactNode} from 'react';
import style from './LayoutContentWrapper.module.css'
import clsx from 'clsx';


interface ILayoutContentWrapper {
    children: ReactNode,
    customClassNameBodyWrapper?: string,
    customClassNameContentWrapper?: string
}

const LayoutContentWrapper = ({children, customClassNameBodyWrapper = '', customClassNameContentWrapper = ''}: ILayoutContentWrapper) => {

    return (
        <div className={clsx(style.appWrapper, customClassNameBodyWrapper)}>
            <div className={clsx(style.contentWrapper, customClassNameContentWrapper)}>
                {children}
            </div>
        </div>
    );
};

export default LayoutContentWrapper;